import { useEffect } from "react";
import apiClient from "../../api/apiClient";

export const DAYS = ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"];

export const MOCKAPPS = [
  { date: new Date(2023,11,27), address: "Removal",title: "Compaign end", color: "#238783" },
  { date: new Date(2023, 2, 6), address: "install", color: "red" },
  {
    "date": new Date("2023-11-26T19:00:00.000Z"),
    "vehicle_id": 72,
    "time": "19:24",
    "event_type": 3,
    "address": "gjjhj",
    "color": "#679538",
    "campaign_id": 8
},

  {
      "id": 1,
      "user_id": "53",
      "campaign_id": "9",
      "address": "Nam in qui nostrum a",
      "date": new Date("2023-11-28"),
      "time": "06:42:00",
      "event_type": 6,
      "vehicle_id": 72,
      color:"red",
  },
  {
      "id": 2,
      "user_id": "53",
      "campaign_id": "9",
      "address": "Voluptatum consectet",
      "date": new Date("2023-11-22"),
      "time": "01:41:00",
      color:"red",
      "event_type": 5,
      "vehicle_id": 72
  },


  // { date: new Date(2023, 2, 25), title: "Compaign end", color: "red" },
  // { date: new Date(2023, 2, 2), title: "Copamign Start", color: "white" }
];
